import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';

import Loading from '../../Components/Loading';

import { queryMyExamScore } from '../../GraphQL/query/Exam.query';
import { mutateScores } from '../../GraphQL/mutation/MyExamScore.mutation';

import ScoreForm from '../../Components/ScoreForm';
import ErrorView from '../../Components/Error';
import { isMed } from '../../Util/Subject';
import { getNumberVariant, getFormattedNumber } from '../../Components/Base/Number';

const convertExamWithScore = (exams = []) =>
  exams.map(exam => ({
    title: exam.name,
    ...exam,
  }));

const convertMockExamScores = (mockExamScores = [], exams) => {
  const scores = {};
  mockExamScores.forEach(mockExamScore => {
    const { subjectCode } = mockExamScore;

    const exam = exams.find(exam => exam.subjectCode === subjectCode);
    if (exam && exam.id) {
      scores[exam.id] = getFormattedNumber(
        mockExamScore.score,
        getNumberVariant(isMed(subjectCode) ? 'meds' : 'other')
      );
    }
  });
  return scores;
};

/*
 *   [{examId: Number1, examScore: Number2}] -> {{Number1: Number2}, ...}
 */
const convertLoadExamScore = (examScores = []) => {
  const results = {};
  examScores.forEach(s => {
    results[s.examId] = getFormattedNumber(s.examScore);
  });
  return results;
};

const myScoreConverter = (myScores = {}) => {
  return Object.entries(myScores).map(score => ({
    examId: score[0],
    examScore: +score[1],
  }));
};

class ScoreFormGQL extends Component {
  render() {
    const { mockExamScores } = this.props;

    // console.count('ScoreFormGQL render()');
    return (
      <Query query={queryMyExamScore}>
        {({ loading, error, data }) => {
          if (loading)
            return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
          if (error) return <ErrorView />;
          // console.log('queryExams:', data);
          const { exams, myProfile } = data;
          const { myScores } = myProfile || {};

          const convertedExams = convertExamWithScore(exams);
          const convertedMockExamScores = mockExamScores
            ? convertMockExamScores(mockExamScores, convertedExams)
            : {};
          const convertedMyScores = convertLoadExamScore(myScores);

          return (
            <Mutation mutation={mutateScores}>
              {(setMyScores, { loading: mutationLoading, mutationError: error }) => (
                <ScoreForm
                  {...this.props}
                  submitLoading={mutationLoading}
                  exams={convertedExams}
                  myScores={convertedMyScores}
                  myMockExamScores={convertedMockExamScores}
                  onSubmit={formData => {
                    // console.log('MyDept ScoreForm data:', formData);
                    const convertedScore = myScoreConverter(formData);
                    if (!mutationLoading && convertedScore.length > 0) {
                      setMyScores({ variables: { myScores: convertedScore } });
                    }
                  }}
                />
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default ScoreFormGQL;
